import Tag from './Tag';
import ForParts from './ForPartsTag';
import Container from './TagContainer';

export default { Tag, Container, ForParts };
